// extracted by mini-css-extract-plugin
export default {"paneContent":"paneContent---B7bRA","logsList":"logsList---BxAfK"};